module.exports = __webpack_public_path__ + "static/media/blueLines.bdbd7ac7.svg";